import { render, staticRenderFns } from "./EditorNew.vue?vue&type=template&id=9e912012&scoped=true"
import script from "./EditorNew.vue?vue&type=script&lang=js"
export * from "./EditorNew.vue?vue&type=script&lang=js"
import style0 from "./EditorNew.vue?vue&type=style&index=0&id=9e912012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e912012",
  null
  
)

export default component.exports